export const setBaseUrl = () => {
    let url = window.location.href; 

    if (url.includes("localhost") || url.includes("dev"))
        localStorage.setItem("base_url", "https://dev-api.otma.org.my")
    else
        localStorage.setItem("base_url", "https://api.otma.org.my")
}